var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.832,
    height: 17.494
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 849",
    opacity: 0.4,
    fill: "none",
    stroke: "#292a33",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2344",
    d: "M6.768 1.413H1v15.08h15.418v-5.047",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2345",
    d: "m7.803 10.485 8.615-9.072"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2346",
    d: "M12.048 1.413h4.37v4.536",
    strokeLinejoin: "round"
  }))));
};
export { SvgExport as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy44MzIiIGhlaWdodD0iMTcuNDk0IiB2aWV3Qm94PSIwIDAgMTcuODMyIDE3LjQ5NCI+DQogIDxnIGlkPSJHcm91cF84NDkiIGRhdGEtbmFtZT0iR3JvdXAgODQ5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjM3LjgxMyAtMjMyLjU1NCkiIG9wYWNpdHk9IjAuNCI+DQogICAgPHBhdGggaWQ9IlBhdGhfMjM0NCIgZGF0YS1uYW1lPSJQYXRoIDIzNDQiIGQ9Ik0tMTM3LjU4NCwzNzY4Ljk2N2gtNS43Njh2MTUuMDhoMTUuNDE4VjM3NzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4Mi4xNjUgLTM1MzUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMyOTJhMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+DQogICAgPHBhdGggaWQ9IlBhdGhfMjM0NSIgZGF0YS1uYW1lPSJQYXRoIDIzNDUiIGQ9Ik0tMTM1LjI2MSwzNzc5LjQ4OWw4LjYxNS05LjA3MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzgwLjg3NyAtMzUzNi40NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzI5MmEzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4NCiAgICA8cGF0aCBpZD0iUGF0aF8yMzQ2IiBkYXRhLW5hbWU9IlBhdGggMjM0NiIgZD0iTS0xMzEuMTksMzc2OC45NjdoNC4zN3Y0LjUzNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzgxLjA1MSAtMzUzNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzI5MmEzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";